import React from 'react';

const GoogleAuthButton = ({ 
  text = 'Continue with Google', 
  onClick = () => console.log('google auth clicked'), 
  loading = false, 
  disabled = false, 
  className = '' 
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      aria-disabled={disabled || loading}
      className={`
        relative flex h-11 w-full items-center justify-center rounded-lg border border-slate-300 bg-white px-4 py-2 
        text-sm font-medium text-slate-700 transition-colors 
        hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-[#1B9DA2] focus:ring-offset-1 
        disabled:cursor-not-allowed disabled:opacity-50 
        ${className}
      `}
    >
      {loading ? (
        <div className="flex items-center gap-2">
          <svg className="h-4 w-4 animate-spin text-slate-500" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <span>Loading...</span>
        </div>
      ) : (
        <>
          <div className="absolute left-4">
            <svg width="18" height="18" viewBox="0 0 18 18">
              <path
                fill="#4285F4"
                d="M17.64 9.2c0-.63-.06-1.25-.16-1.84H9v3.47h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.91a8.78 8.78 0 0 0 2.69-6.6z"
              />
              <path
                fill="#34A853"
                d="M9 18c2.38 0 4.38-.79 5.84-2.13l-2.91-2.26c-.8.54-1.83.86-2.93.86-2.25 0-4.16-1.52-4.84-3.57H1.14v2.33A8.99 8.99 0 0 0 9 18z"
              />
              <path
                fill="#FBBC05"
                d="M4.16 10.9a5.4 5.4 0 0 1 0-3.45V5.12H1.14a8.99 8.99 0 0 0 0 7.76l3.02-2.33z"
              />
              <path
                fill="#EA4335"
                d="M9 3.58c1.3 0 2.47.45 3.39 1.32l2.54-2.54A8.93 8.93 0 0 0 9 0 8.99 8.99 0 0 0 1.14 5.12l3.02 2.33C4.84 5.1 6.75 3.58 9 3.58z"
              />
            </svg>
          </div>
          <span>{text}</span>
        </>
      )}
    </button>
  );
};

export default GoogleAuthButton;
